import { render, staticRenderFns } from "./UGroupSimple.vue?vue&type=template&id=1761d69d&"
import script from "./UGroupSimple.vue?vue&type=script&lang=js&"
export * from "./UGroupSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports